import CollapsibleActionMenu from '@/components/CollapsibleActionMenu';
import { type ActionMenuButtonProps } from '@/components/CollapsibleActionMenu/ActionMenuButton';
import { FormattedMessage } from 'react-intl';

type DeleteRowButtonProps = Omit<ActionMenuButtonProps, 'children'>;

const DeleteRowButton = (props: DeleteRowButtonProps) => (
  <CollapsibleActionMenu.DeleteButton {...props}>
    <FormattedMessage id="portfolio.row.mobile_row_actions.delete_button" />
  </CollapsibleActionMenu.DeleteButton>
);

export default DeleteRowButton;
